import type { Schedule } from '@iheartjane/types';

import type { MenuRow } from '@jane/business-admin/types';

export type ApplyToMode = 'advanced' | 'products';

export const FORM_ERROR_NAME = 'menu-row-errors';

/**
 * Shape of the react-hook-form values for creating or editing a MenuRow.
 *
 * The fields are:
 * 1. Picked directly from the MenuRow model.
 * 2. NonNullable variations of MenuRow fields (like row_type and menu_row_type).
 * 3. Flattened or meta params.
 */
export type FormValues = Pick<
  MenuRow,
  | 'applicability_rules'
  | 'custom_display_name'
  | 'enabled'
  | 'end_time'
  | 'ranking'
  | 'rules'
  | 'start_time'
> & {
  apply_to?: ApplyToMode;
  display: { category: string; subcategory: string };
  enabled_date_end?: string;
  enabled_date_end_checked?: boolean;
  enabled_date_start?: string;
  enabled_date_start_checked?: boolean;
  end_date?: string;
  /** Form-wide error key */
  [FORM_ERROR_NAME]?: null;
  has_schedule_overrides: boolean;
  menu_row_type: string;
  row_type: string;
  schedule: Schedule;
  start_date?: string;
  use_store_close_time?: boolean;
};
